import React from "react";
import { Text, TextProps } from "react-native";

type Props = TextProps & {
  children: React.ReactNode;
};

export const FormLabel: React.FC<Props> = ({
  children,
  className = "",
  ...rest
}) => {
  return (
    <Text
      className={`text-xs font-bold uppercase text-gray-700 tracking-widest mb-2 ml-1 ${className}`}
      {...rest}
    >
      {children}
    </Text>
  );
};

export default FormLabel;
